import { PopularCity } from "./LocationSetupTypes";

export const LOCATION_STORAGE_KEY = "salar_delivery_location";
export const LOCATION_GATE_SESSION_KEY = "salar_require_location";
export const ADDRESS_SETUP_EVENT = "salar-open-address-setup";

export const defaultMapLocation = {
    latitude: 20.5937,
    longitude: 78.9629,
};

export const popularCities: PopularCity[] = [
    {
        id: "hyderabad",
        name: "Hyderabad",
        state: "Telangana",
        latitude: 17.385,
        longitude: 78.4867,
        iconClass: "bi bi-buildings",
    },
    {
        id: "bengaluru",
        name: "Bengaluru",
        state: "Karnataka",
        latitude: 12.9716,
        longitude: 77.5946,
        iconClass: "bi bi-buildings",
    },
    {
        id: "chennai",
        name: "Chennai",
        state: "Tamil Nadu",
        latitude: 13.0827,
        longitude: 80.2707,
        iconClass: "bi bi-buildings",
    },
    {
        id: "mumbai",
        name: "Mumbai",
        state: "Maharashtra",
        latitude: 19.076,
        longitude: 72.8777,
        iconClass: "bi bi-buildings",
    },
    {
        id: "delhi",
        name: "Delhi NCR",
        state: "Delhi",
        latitude: 28.6139,
        longitude: 77.209,
        iconClass: "bi bi-buildings",
    },
    {
        id: "pune",
        name: "Pune",
        state: "Maharashtra",
        latitude: 18.5204,
        longitude: 73.8567,
        iconClass: "bi bi-buildings",
    },
    {
        id: "kolkata",
        name: "Kolkata",
        state: "West Bengal",
        latitude: 22.5726,
        longitude: 88.3639,
        iconClass: "bi bi-buildings",
    },
    {
        id: "ahmedabad",
        name: "Ahmedabad",
        state: "Gujarat",
        latitude: 23.0225,
        longitude: 72.5714,
        iconClass: "bi bi-buildings",
    },
];
